import { trackEvent } from '@svenskaspelab/nova-core/nextjs/analytics';
import Clock from '@svenskaspelab/ui/react/icons/TimeLimit';

import { trackEventConfig } from '../constants.js';

export function realityChecksDialogConfig(onAcknowledge: () => void, onLogout: () => void, loggedInMinutes: number) {
  const loggedInText = loggedInMinutes > 60 ? 'ytterligare en timme' : 'en timme';
  return {
    icon: <Clock />,
    title: 'Har du koll på tiden?',
    description: (
      <>
        <p>Nu har du varit inloggad {loggedInText}.</p>
        <p>Tiden kan gå fort när man spelar. Varför inte ta en paus och göra något annat en stund?</p>
      </>
    ),
    buttons: {
      primary: {
        label: 'Spela vidare',
        action: () => {
          void onAcknowledge();
        },
      },
      secondary: {
        label: 'Logga ut',
        action: () => {
          void onLogout();
        },
      },
    },
  };
}

export default function showRealityChecksDialog(loggedInMinutes: number, logout: () => Promise<void>) {
  return realityChecksDialogConfig(
    () =>
      trackEvent({
        ...trackEventConfig,
        optLabel: 'Continue',
      }),
    () => {
      trackEvent({
        ...trackEventConfig,
        optLabel: 'Logout',
      });
      void logout();
    },
    loggedInMinutes
  );
}
